<template>
  <div  class="role-auth">
      <div class="role-auth-bottom">
      <div class="role-auth-aside">
        <div key="0" class="role-auth-table">
          <div class="role-auth-bar">
            <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable >
              <template #prefix><i class="el-icon-search el-input__icon" /></template>
            </el-input>
            <i class="el-icon-circle-plus-outline" style="cursor: pointer" @click="addRoleHandler()" v-if="addSysRoleConfig"></i>
          </div>
          <el-tree ref="roletree" :data="roleList" :props="defaultRoleProps" :filter-node-method="filterNode" :expand-on-click-node="false" node-key="roleID" highlight-current default-expand-all class="role-auth-tree" @node-click="systemTableClick" >
            <template #default="{ data }">
              <div class="tree-content" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)" >
                <div class="tree-content-header">
                  <img  :src="role_png" style="margin-right: 6px" alt="图片"/>
                   
                  <span :title="data.roleName" class="textAll">{{ data.roleName }}</span>
                </div>
                <div v-if="!data.defaultFlag" style="color: #4777e7;font-size:16px">
                  <i v-show="data.show && data.$isOperation&&editSpecConfig" class="el-icon-edit-outline" @click="updateMajorHandler(data)" > </i >
                  <i v-show="data.show && !data.$isOperation && editRoleConfig" class="el-icon-edit-outline" @click="updateRoleHandler(data)" > </i >
                  <i v-show="data.show && data.$isOperation && deleSpecConfig" class="el-icon-delete" @click="deleteRoleHandler(data)" ></i >
                  <i v-show="data.show && !data.$isOperation && deleRoleConfig" class="el-icon-delete" @click="deleteRoleHandler(data)" ></i >
                </div>
              </div>
            </template>
          </el-tree>
        </div>
      </div>
      <!-- 右侧内容区域 -->
      <div class="role-auth-content">
        <div v-if="systemAddOption.roleID&&systemAddOption.$isOperation!=1" style="height:100%">
          <template>
            <div class="role-auth-content-top">
              <div>
                <span>包含人员</span>
                <el-button type="text" size="small" @click="addRolePersonHandler" v-if="addRoleUserConfig">添加人员</el-button >
              </div>
              <div class="content-people">
                <div v-for="row in personList" :key="row.id" class="people-content" >
                  <img v-if="row.defaultFlag" :src="default_png" alt="图片"/>
                  <img v-else-if="!row.defaultFlag && deleRoleUserConfig" :src="reject_png" alt="图片"  @click="delRolePersonHandler(row)"/>
                  <img v-else :src="default_png" alt="图片" />
                  {{ row.name }}({{ row.username }})
                </div>
              </div>
            </div>
            <div class="role-auth-project-top">权限分配</div>
            <div v-loading="tableLoading" class="role-auth-modules-nolist" element-loading-text="数据加载中..." :class="[{ moduleslist: personList&&personList.length>0 }]" >
              <el-table :indent="16" :tree-props="moduleTreeProp" :data="moduleTree" :row-style="rowStyle" :cell-style="cellStyle" :show-header="false" :header-cell-style="headerStyle" row-key="permissionId" border height="100%" default-expand-all >
                <template slot="empty">
                  <img :src="zanwu" alt="图片" />
                  <p style="font-size:16px;color:#000;">暂无数据</p>
                </template>
                <el-table-column class-name="table-module-name" width="400px">
                  <template #default="{ row }">
                    <el-checkbox v-model="row.isChecked" :true-label="1" :false-label="0" :disabled="systemAddOption.roleName=='系统管理员'" :indeterminate="row.indeterminate" @change="checkPermissionClass(row)" >
                      {{ row.permissionName }}
                    </el-checkbox >
                  </template>
                </el-table-column>
                <el-table-column class-name="table-module-name">
                  <template #default="{ row }">
                    <div v-for="(item, index) in row.buttonList" :key="index" style="margin-right: 30px; width: 150px" >
                      <el-checkbox v-model="item.isChecked" :true-label="1" :false-label="0" :disabled="systemAddOption.roleName=='系统管理员'" @change="checkPermissionButton(item)" >
                        {{ item.permissionName }}
                      </el-checkbox >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="role-auth-modules-footer">
              <el-button v-if="systemAddOption.roleName!='系统管理员'" :disabled="isDisabled" type="primary" size="small" @click="submitModulesHandler" >提交权限</el-button >
            </div>
          </template>
        </div>
        <template v-else>
          <div class="empty mt-40">请选择左侧角色</div>
        </template>
      </div>
    </div>
   
    <el-dialog v-dialogDrag :visible.sync="roleDialog" :before-close="roleClose" :close-on-click-modal="false" :close-on-press-escape="false" :title="roleTitle" width="500px" >
      <el-form ref="roleForm" :model="roleForm" :rules="rules" >
         
        
        <el-form-item label="专业名称" prop="specName">
          <el-input v-model="roleForm.specName" maxlength="15" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleClose">取 消</el-button >
        <el-button type="primary" @click="getRoleContain" v-preventReClick >确 定</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 代码是我拆开的但不是我写的 有问题去看标准协同此文件的提交日志[\mainMg\settings\permission\index.vue]
 * @author xmetaki(lgz)
 */
import role from "@/CommonDP/service/privi-service";
import asyncCom from "@/CommonDP/commons/asyncCom";
import FrameWork from "@/CommonDP/components/FrameWork/index";
import { getTreeData } from "@/CommonDP/utils/tree"
import { disablePrompt,checkPermission } from "@/CommonDP/utils/routeAuth"
import { mapState } from "vuex";
import { SYS_ROLE } from '@/views/constant/role'
import checkHelper from '../mixins/checkHelper'
const newForm = () => ({
  specId: "",
  roleName: "",
  specName:""
});
export default {
    mixins:[checkHelper],
    data() {
        return {
            default_png: require('@/CommonDP/assets/approval/default.png'),
            reject_png: require('@/CommonDP/assets/approval/reject.png'),
            zanwu: require('@/CommonDP/assets/暂无数据.png'),
            role_png: require('@/CommonDP/assets/settings/systemRole.png'),
            systemAddOption: {
                roleID: "",
                $isOperation: "",
                roleName: "",
                pid: "",
                id: ""
            },
            moduleTreeProp: {
                children: "childList"
            },
            defaultRoleProps: {
                children: "childList",
                label: "roleName"
            },
            roleList: [], // 角色列表
            personList: [], // 角色下人员
            filterText: "",
            tableLoading: false,
            roleForm: newForm(),
            roleDialog: false,
            rules: {
                roleName: [
                { required: true, message: "请输入角色名称", trigger: "blur" }
                ],
                specName: [
                { required: true, message: "请输入专业名称", trigger: "blur" }
                ],
            },
            addSysRoleConfig: checkPermission(":rolePowerConfig:addSysRole"),
            editRoleConfig: checkPermission(":rolePowerConfig:editRole"),
            deleRoleConfig: checkPermission(":rolePowerConfig:deleRole"),
            editSpecConfig: checkPermission(":rolePowerConfig:editSpec"),
            deleSpecConfig: checkPermission(":rolePowerConfig:deleSpec"),
            addRoleUserConfig: checkPermission(":rolePowerConfig:addRoleUser"),
            deleRoleUserConfig: checkPermission(":rolePowerConfig:deleRoleUser"),
        };
    },
    computed: {
      submitList() {
        const newarr = []
        this.getTreeDataByFilter(this.moduleTree, newarr);
        return newarr
      },
      // 判断是否与原数据发生变化
      isDisabled() {
        return JSON.stringify(this.initModuleTree) === JSON.stringify(this.submitList)
      },
      roleType() {
        if (this.$route.query.ID) {
          return this.$route.query.ID.split("-")[0];
        } else {
          return SYS_ROLE
        }
      },
      ...mapState({
        enterpriseId: state => state.enterprise.enterpriseId,
      }),
      roleTitle(){
        return ['添加专业','添加角色'][this.submitType]
      }
    },
  watch: {
    filterText(val) {
      this.$refs.roletree.filter(val);
    }
  },
  created() {
    this.getRoleList();
  },

  methods: {
    mouseenter(data) {
      this.$set(data, "show", true);
    },
    mouseleave(data) {
      this.$set(data, "show", false);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },
    // 删除 角色
    deleteRoleHandler(row) {
      const a = disablePrompt()
      if (a) {
        const { $confirm, $message, getRoleList, roleType } = this;
        const { roleID, roleName } = row;
        $confirm(`确定删除系统角色 ${roleName}?`, "警告", {
            type: "warning"
        }).then(() => role.delSysRole(roleID)).then(() => {
            this.$router.push({ query: { ID: roleType + `-` + "" }})
            $message({ type: "success", message: "删除角色成功" });
        }).then(() => {
            getRoleList();
        });
      }
    },
    // 提交已修改模块树
    async submitModulesHandler() {
      const a = disablePrompt()
      if (a) {
        const list = this.moduleTree;
        const roleID = this.systemAddOption.roleID;
        var newarr = [];
        this.getTreeDataByFilter(list, newarr)
        const rolePermissionDetailList = newarr.map((item) => {
          return { permissionId: item.permissionId, isParentPage: item.isParentPage };
        });
        const params = { enterpriseId: this.enterpriseId, roleId: roleID, rolePermissionDetailList };
        const res = await role.addRolePermission(params);
        if (res.result === "0") this.$message.success("保存成功");
        this.modellist(roleID);
        await this.$store.dispatch('GetModuleList', this.enterpriseId)
      }
    },
    getTreeDataByFilter(data, newarr) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].isChecked === 1) {
          newarr.push({ permissionId: data[i].permissionId, isParentPage: data[i].isParentPage });
        }
        if (data[i].childList && data[i].childList.length > 0) {
          this.getTreeDataByFilter(data[i].childList, newarr);
        } else if (data[i].buttonList && data[i].buttonList.length > 0) {
          this.getTreeDataByFilter(data[i].buttonList, newarr);
        }
      }
      return newarr;
    },
    systemTableClick(row) {
      this.systemAddOption.$isOperation = row.$isOperation
      this.systemAddOption.roleName = row.roleName
      this.initEmptyModule();
      this.systemAddOption.id = row.id;
      this.systemAddOption.roleID = row.roleID;
      this.systemAddOption.pid = row.pid;
      if (row.roleID && row.pid && !this.systemAddOption.$isOperation) {
        this.getPersonList(row.roleID, row.roleName);
        this.$router.push({ query: { ID: this.roleType + `-` + row.roleID + `-` + row.roleName }})
        this.modellist(row.roleID);
      }
    },
    // 初始化 模块树 -> 空
    initEmptyModule() {
      this.moduleTree = [];
      this.personList = [];
      this.systemAddOption.roleID = "";
    },
    // 获取模块
    modellist(roleID) {
      this.tableLoading = true;
      const params = { roleId: roleID, businessType: this.roleType, enterpriseId: this.enterpriseId };
      role.queryPermissionTreeForEnterpriseCheck(params).then(({ data }) => {
        this.moduleTree = data || [];
        getTreeData(this.moduleTree);
        this.refreshCheckboxStatus(this.moduleTree)
        this.tableLoading = false;
        var list = [];
        this.getTreeDataByFilter(this.moduleTree, list)
        this.initModuleTree = JSON.parse(JSON.stringify(list))
      });
    },
  
    // 删除角色下人员
    delRolePersonHandler(row) {
      const a = disablePrompt()
      if (a) {
        const roleID = this.systemAddOption.roleID;
        const roleName = this.systemAddOption.roleID;
        const { $confirm, $message, getPersonList } = this;
        const { userId, username, name } = row;
        $confirm(`确定删除人员 ${name}${username} 的角色权限?`, "警告", {
          type: "warning"
        })
          .then(() => role.delSysRoleUser(roleID, userId))
          .then(() => {
            getPersonList(roleID, roleName);
            $message({ type: "success", message: "删除角色人员成功" });
          });
      }
    },
    // 添加系统角色
    addRoleHandler() {
      const a = disablePrompt()
      if (a) {
        this.$prompt("请输入角色名称", "添加角色", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: "请输入角色名称",
          inputErrorMessage: "请输入除空格外的15文字以内的角色名称",
          inputPattern: /^\S{1,15}$/,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose:async (action, { inputValue }, done) => {
            if (action === "confirm"){
              const form = { roleName: inputValue, enterpriseId: this.enterpriseId };
              try {
                const result = await role.saveSysRole(form)
                if (result.result === '0') {
                  this.$message({ type: "success", message: "角色添加成功" });
                  this.getRoleList();
                  done();
                }
              } catch (e) {
                this.$message({ type: "error", message: "角色添加失败" });
              }
            }else {
              done();
            }
            
          }
        });
      }
    },
   
   
    // 项目专业添加自定义角色
    async getRoleContain() {
      await this.$refs.roleForm.validate();
      const { roleForm: { specId, roleName ,specName}, enterpriseId ,submitType} = this;
      if(submitType===1){
        const params = { specId, roleName, enterpriseId };
        await role.addPrjRole(params);
        await this.$message({ type: "success", message: "角色添加成功" });
        
      }else{
        const params = { specName, enterpriseId };
        const res=await role.addPrjSpec(params);
        if(res.result==="0")  await this.$message({ type: "success", message: "专业添加成功" });
      }
      await this.roleClose()
      await this.getRoleList();
    },
    roleClose() {
      this.roleDialog = false;
      this.disableRole=false
      this.$refs.roleForm.resetFields();
    },
    updateRoleHandler({ roleID, roleName, id }) {
      const a = disablePrompt()
      if (a) {
        const { $prompt } = this;
        $prompt("请输入角色名称", "编辑角色名称", {
          inputPlaceholder: "编辑角色名称",
          inputValue: roleName,
          inputErrorMessage: "请输入除空格外的15文字以内的角色名称",
          inputPattern: /^\S{1,15}$/,
          beforeClose: (action, { inputValue }, done) => {
            if (action === "cancel") done();
            else {
              const { updateRole, enterpriseId } = this;
              const form = { roleName: inputValue, roleId: roleID, enterpriseId };
              const majorForm = { specName: inputValue, id, enterpriseId }
              updateRole(form, majorForm).then(() => {
                done();
              });
            }
          }
        });
      }
    },
    updateMajorHandler({ roleID, roleName, id }) {
      const a = disablePrompt()
      if (a) {
        const { $prompt } = this;
        $prompt("请输入专业名称", "编辑专业名称", {
          inputPlaceholder: "编辑专业名称",
          inputValue: roleName,
          inputErrorMessage: "请输入除空格外的15文字以内的专业名称",
          inputPattern: /^\S{1,15}$/,
          beforeClose: (action, { inputValue }, done) => {
            if (action === "cancel") done();
            else {
              const { updateRole, enterpriseId } = this;
              const form = { roleName: inputValue, roleId: roleID, enterpriseId };
              const majorForm = { specName: inputValue, id, enterpriseId }
              updateRole(form, majorForm).then(() => {
                done();
              });
            }
          }
        });
      }
    },
    // 修改角色
    updateRole(form, majorForm) {
        return role.updateSysRole(form).then(() => {
            this.$message({ type: "success", message: "角色修改成功" });
            this.getRoleList();
        });
    },
    // 向角色添加人
    addRolePersonHandler() {
      const a = disablePrompt()
      if (a) {
        const {
          getPersonList,
          systemAddOption: { roleID, roleName }
        } = this;
        const data = { min: 1 };
        asyncCom(FrameWork, data).then((data) => data.map((user) => user)).then((user) => {
          const form = user.map((item) => {
            return { userId: item.userId, roleId: roleID, enterpriseId: this.enterpriseId };
          });
          return role.addSysRoleUser(form);
        }).then(() => {
          this.$message.success({ message: "添加人员成功" });
        }).then(() => getPersonList(roleID, roleName));
      }
    },
    // 获取角色 并设置默认选中且刷新浏览器人保存
    async getRoleList() {
        if (this.$route.query.ID) {
            var roleID = this.$route.query.ID.split("-")[1]
            var roleName = this.$route.query.ID.split("-")[2]
        }
        role.querySysRoleList(this.enterpriseId).then(({ data }) => {
            this.roleList = data.map((item) => {
            item.childList = [];
            item.pid = "0";
            return item;
            });
            if (roleID) {
            this.modellist(roleID);
            this.getPersonList(roleID, roleName);
            this.$nextTick(() => {
                if (this.$refs.roletree) {
                this.$refs.roletree.setCurrentKey(roleID)
                }
            })
            this.$router.push({ query: { ID: this.roleType + `-` + roleID + `-` + roleName }})
            this.systemAddOption.roleID = roleID;
            this.systemAddOption.roleName = roleName
            } else {
            if (this.roleList && this.roleList.length > 0) {
                this.getPersonList(this.roleList[0].roleID, this.roleList[0].roleName);
                this.modellist(this.roleList[0].roleID);
                this.$nextTick(() => {
                if (this.$refs.roletree) {
                    this.$refs.roletree.setCurrentKey(this.roleList[0].roleID)
                }
                })
                this.$router.push({ query: { ID: this.roleType + `-` + this.roleList[0].roleID + `-` + this.roleList[0].roleName }})
                this.systemAddOption.roleID = this.roleList[0].roleID;
                this.systemAddOption.roleName = this.roleList[0].roleName
            }
            }
        });
      
    },
    // 获取角色下人员
    getPersonList(roleId, roleName) {
      const { enterpriseId } = this;
      const params = { roleId, enterpriseId, roleName, type: 3 };
      return role.getSysRoleUserList(params).then(({ data }) => {
        this.personList = data;
      });
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
    cellStyle({ columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "background: rgba(118, 137, 173, 0.04)";
      }
    }
  }
}
</script>

<style lang="scss" scoped src="../styles/sysRole.scss"/>